
import { isEqual, omit } from "lodash";
import { mapActions, mapState, mapGetters } from "vuex";
import {
  ORDER_DETAIL_PAGE_VISITED,
  ORDER_MODIFIED
} from "@/constants/MixpanelEvents.js";
import BackButtonOutlined from "../common/back-button-outlined.vue";
import OrderDetailsActionRow from "./order-details-action-row.vue";
import OrderDetailsDeliveryDetails from "./order-details-delivery-details.vue";
import orderDetailsItemDetails from "./order-details-item-details.vue";
import OrderDetailsOrderDuration from "./order-details-order-duration.vue";
// import OrderDetailsOrderStatusStepper from "./order-details-order-status-stepper.vue";
import OrderDetailsRiderDetails from "./order-details-rider-details.vue";
import OrderDetailsBillAmountRow from "./order-details-bill-amount-row.vue";
import OrderDetailsCardMobile from "./order-details-card-mobile.vue";
import OrderDetailsAppBar from "./order-details-app-bar.vue";
import OrderActionButton from "./order-action-btn.vue";
import OrderDetailsPriceBreakup from "./order-details-price-breakup.vue";
import CommonAccessDenied from "../common/common-access-denied.vue";
import unAuthorisedAccessImage from "~/assets/images/unAuthorisedAccessImage.svg";
export default {
  components: {
    orderDetailsItemDetails,
    BackButtonOutlined,
    OrderDetailsActionRow,
    OrderDetailsDeliveryDetails,
    OrderDetailsRiderDetails,
    OrderDetailsOrderDuration,
    OrderDetailsBillAmountRow,
    OrderDetailsCardMobile,
    OrderDetailsAppBar,
    OrderActionButton,
    OrderDetailsPriceBreakup,
    CommonAccessDenied
  },
  data() {
    return {
      secondsSinceCreated: 0,
      isOrderCancelled: false,
      unavailableItems: [],
      itemOutOfStockLoading: false,
      showAvailabilityToggleInDetailsPage: false,
      timer: null,
      unAuthorisedAccessImage
    };
  },
  props: {
    orderId: ""
  },
  created() {
    this.$nuxt.$on("availability-toggled", (data) => {
      this.unavailableItems = [
        ...this.getUpdatedUnavailableItems(this.unavailableItems, data)
      ];
    });
  },
  beforeMount() {
    this.getOrderDetails({
      orderId: this.orderId
    }).then((response) => this.populateUnavailableItems(response.data));
  },
  mounted() {
    this.mixPanelTrackEvent(ORDER_DETAIL_PAGE_VISITED);
    this.timer = setInterval(() => {
      this.secondsSinceCreated++;
    }, 1000);
  },
  watch: {
    orderDetails(val) {
      this.secondsSinceCreated = 0;
      this.isOrderCancelled = val.status == 1;
    },
    currentOrder: {
      handler(newOrder, oldOrder) {
        const newOrderFiltered = omit(newOrder, ["duration"]);
        const oldOrderFiltered = omit(oldOrder, ["duration"]);

        if (!isEqual(newOrderFiltered, oldOrderFiltered)) {
          this.getOrderDetails({
            orderId: this.orderId,
            silent: true
          });
        }
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters("reciever", ["getSelectedChannelNewOrders", "getOrderById"]),
    ...mapState("reciever", ["orderDetails", "orderDetailsLoading", "orders"]),
    ...mapGetters("restaurant", ["getRestaurantFeatures"]),
    currentOrder() {
      return this.getOrderById(this.orderDetails.id);
    },
    isModificationEnabled() {
      return (
        this.getRestaurantFeatures(this.orderDetails.restaurant_id)
          ?.order_modification &&
        this.orderDetails?.status ===
          this.$constants.OrderStatuses.PREPARING.id &&
        this.orderDetails?.source === this.$constants.Channels.SWIGGY.name
      );
    },
    isUpdateAndNotifyButton() {
      const filteredOrder = this.unavailableItems.find(
        (item) => item.orderId === this.orderDetails.id
      );
      return filteredOrder && filteredOrder.items.length > 0;
    }
  },
  methods: {
    ...mapActions("reciever", ["getOrderDetails", "markItemOutOfStock"]),
    showAvailabilityToggle() {
      this.showAvailabilityToggleInDetailsPage = true;
    },
    hideAvailability() {
      this.showAvailabilityToggleInDetailsPage = false;
      this.unavailableItems.forEach((item) => (item.items = []));
    },
    populateUnavailableItems(order) {
      this.unavailableItems = [];
      const data = {
        orderId: order.id,
        items: []
      };
      this.unavailableItems.push(data);
    },
    async handleFetchOrders() {
      await this.sleep(1000);
      this.getOrders();
    },
    handleUpdateAndNotify() {
      this.itemOutOfStockLoading = true;
      const filteredOrder = this.unavailableItems.find(
        (item) => item.orderId === this.orderDetails.id
      );
      this.markItemOutOfStock({
        orderId: filteredOrder.orderId,
        payload: { items: filteredOrder.items }
      })
        .then((response) => {
          this.mixPanelTrackEvent(ORDER_MODIFIED);
          this.$nuxt.$emit("show-toast", {
            text: response.data.message,
            color: "success darken-2",
            icon: "done",
            flat: true
          });
          this.$router.push("/reciever");
          this.handleFetchOrders();
        })
        .catch((errr) => {
          console.log(errr);
          this.$nuxt.$emit("show-error-toast", errr);
        })
        .finally(() => {
          this.itemOutOfStockLoading = false;
        });
    }
  },
  beforeDestroy() {
    this.$nuxt.$off("availability-toggled");
    clearInterval(this.timer);
  }
};
